<template>
  <div>
    <v-data-table
        :headers="table.headers"
        :header-props="{ sortIcon: null, headerClass: 'white-space-no-wrap' }"
        :items="getAffiliatesProfileCO.data"
        :server-items-length="getAffiliatesProfileCO.count"
        :disable-sort="true"
        :loading="table.loading"
        :footer-props="{itemsPerPageOptions: table.pageOptions}"
        :page="table.currentPage"
        :items-per-page="table.perPage"
        loading-text="Loading... Please wait"
        fixed-header
        :class="`elevation-1 fixed-height co-data-table items-size-${table.heightCounter}`"
        item-class="td_title"
        color="#7F98A5"
        @pagination="updateTablePagination"
        :show-select="showSelect"
        @input="onSelect"
    >
      <template v-slot:top>
        <DataTableTopBar @search="search" :isDisplaySettings="true" :headers="table.headers.map(h=>h.text)" headerType="affiliateHeader"></DataTableTopBar>
      </template>
      <template v-for="item of table.headers" :slot="`header.${[item.value]}`" slot-scope="{header}">
        <data-filter :type="table.filters[header.value]['isDate'] ? 'date' : 'items'"
                     v-if="table.filters.hasOwnProperty(header.value)"
                     :items="table.filters[header.value].data"
                     :entity="header.value"
                     :values="table.filters[header.value].selected"
                     @apply="submitFilter"
                     @search="updateDataInFilters"
        ></data-filter>
        <a v-if="header.sortable === undefined || header.sortable" @click="sortColumn(header.value)">
          <span class="header_title">{{header.text}}</span>
          <v-icon size="16" color="#7F98A5">mdi-arrow-{{header.value === table.orderBy ? table.sortColumnsAsc ? 'up' : 'down' : 'up-down'}}</v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </template>
      <!-- header -->
      <!-- body -->
      <template v-for="header of table.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
        <template v-if="header.value === 'actions'">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <a class="no-underline" :href="getCampainsUrl(item)" v-bind="attrs" v-on="on" target="_blank">
                <v-icon color="accent">mdi-chart-pie</v-icon>
              </a>
            </template>
            <span>Campaigns</span>
          </v-tooltip>
          <v-tooltip v-if="item.isSelectable" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="activateEmailManually(item)">
                <v-icon v-if="item.verified">mdi-email</v-icon>
                <v-icon v-else>mdi-email-outline</v-icon>
              </v-btn>
            </template>
            <span v-if="item.verified">Verified Email</span>
            <span v-else>Activate Email Manually</span>
          </v-tooltip>
          <v-tooltip v-if="checkPermissions(item)" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon color="secondary" @click="generateTokenAndLoginToAffiliate(item)">
                <v-icon>mdi-login</v-icon>
              </v-btn>
            </template>
            <span>Login to Affiliate</span>
          </v-tooltip>
        </template>
        <template v-if="header.value === 'currency'">
          <v-tooltip top open-delay="400">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">{{item.currency}}</span>
            </template>
            <span>{{item.currencyName}}</span>
          </v-tooltip>
        </template>
        <template v-else-if="header.value === 'dateAdded'">
          {{getPrettyDate(item.dateAdded)}}
        </template>
        <template v-else-if="header.value === 'verticals'">
          <div class="verticals-container">
            <v-chip
                v-for="(vertical, index) in item.verticals"
                :key="index"
                color="primary"
                class="tag"
                text-color="white">
              {{ vertical.name }}
            </v-chip>
          </div>
        </template>
        <template v-else-if="isEntityName(header.value)">
          <a class="entity-link" @click="showCard(item,  null, header.value)">{{item[header.value]}}</a>
          <v-tooltip top v-if="(item.hasDuplicateName || item.hasDuplicateFingerprint || item.hasDuplicateDeviceId) && header.value === 'affNameId'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small
                     :color="item.hasDuplicateName && item.hasDuplicateNameResolved ? 'success' :
                   (item.hasDuplicateName ? 'error' : (item.hasDuplicateFingerprint ? 'error' : 'primary'))"
                     @click="showCard(item, 'notes')" class="ml-1" icon
              >
                <v-icon small v-if="item.hasDuplicateName && !item.hasDuplicateNameResolved">mdi-shield-alert</v-icon>
                <v-icon small v-else-if="item.hasDuplicateName && item.hasDuplicateNameResolved">mdi-shield-check</v-icon>
              </v-btn>
            </template>
            <span>
              <div v-if="item.hasDuplicateName">Duplicate Name</div>
              <div v-if="item.hasDuplicateNameResolved">Duplicate Name resolved</div>
              <div v-if="item.hasDuplicateFingerprint">Duplicate Fingerprint</div>
              <div v-if="item.hasDuplicateDeviceId">Duplicate Device ID</div>
            </span>
          </v-tooltip>
        </template>
        <template v-else-if="header.value === 'paymentType'">
          <short-text :text="item[header.value]"></short-text>
          <v-tooltip top v-if="item.hasDuplicatePaymentMethod !== undefined">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small
                     :color="item.hasDuplicatePaymentMethod && item.hasDuplicatePaymentMethodResolved ? 'success' : (item.hasDuplicatePaymentMethod ? 'error' : 'primary')"
                     @click="showCard(item, 'notes')" class="ml-1" icon
              >
                <v-icon small v-if="item.hasDuplicatePaymentMethod && !item.hasDuplicatePaymentMethodResolved">mdi-shield-alert</v-icon>
                <v-icon small v-else-if="item.hasDuplicatePaymentMethod && item.hasDuplicatePaymentMethodResolved">mdi-shield-check</v-icon>
              </v-btn>
            </template>
            <span>
              <div>Duplicate Payment Info</div>
              <div v-if="item.hasDuplicatePaymentMethodResolved">Duplicate Payment Info resolved</div>
            </span>
          </v-tooltip>
        </template>
        <template v-else-if="header.value === 'email'">
          <span>{{item.email}} </span>
          <v-tooltip top v-if="item.contacts">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" small color="primary" class="ml-1" icon>
                <v-icon small @click="showContacts">mdi-email</v-icon>
              </v-btn>
            </template>
            <span>
          <div v-for="contact in item.contacts.split(', ').map(contact => contact.trim())" :key="contact">{{ contact }}</div>
        </span>
          </v-tooltip>
        </template>
        <template v-else><short-text :text="item[header.value]"></short-text></template>
      </template>
      <!-- body -->
    </v-data-table>
    <div class="loader-wrapper" v-if="loading">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
    <DataTableBottomBar
        :showFilter="Object.values(table.filters).find(f => f.selected.length) !== undefined"
        @clearFilters="removeAllFilters"
        v-model="table.heightCounter"
    ></DataTableBottomBar>
    <EditProfile v-model="dialog.open" :item="dialog.item" :title="dialog.title"></EditProfile>
    <ExportSettingsModal
            :isShow="exportSettingsDialog.open"
            :headers="table.headers.map(h=>h.value)"
            :example="getAffiliatesProfileCO && getAffiliatesProfileCO.data ?  getAffiliatesProfileCO.data[0] : null"
    >
    </ExportSettingsModal>
    <v-dialog
            v-model="openModalNewAffiliate"
            max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Create Affiliate</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row align="center">
              <v-col cols="12" sm="12" class="col-max-height">
                <v-text-field
                        v-model="newAffiliate.email"
                        label="Email"
                ></v-text-field>
                <span class="custom-error" v-if="showErrors && !newAffiliate.email">required</span>
                <span class="custom-error" v-if="isInvalidEmail">Please, enter a valid email</span>
              </v-col>
              <v-col cols="6" sm="6" class="col-max-height">
                <v-text-field
                        v-model="newAffiliate.firstName"
                        label="First Name"
                ></v-text-field>
                <span class="custom-error" v-if="showErrors && !newAffiliate.firstName">required</span>
              </v-col>
              <v-col cols="6" sm="6" class="col-max-height">
                <v-text-field
                        v-model="newAffiliate.lastName"
                        label="Last Name"
                ></v-text-field>
                <span class="custom-error" v-if="showErrors && !newAffiliate.lastName">required</span>
              </v-col>
              <v-col cols="12" sm="12">
                <DynamicFields
                        v-model="newAffiliate.verticals"
                        label="Vertical"
                ></DynamicFields>
              </v-col>
              <v-col cols="6" sm="6" class="col-max-height">
                <v-text-field
                        v-model="newAffiliate.imType"
                        label="IM Type"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" class="col-max-height">
                <v-text-field
                        v-model="newAffiliate.imUsername"
                        label="Im Username"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <DynamicFields
                        v-model="newAffiliate.traffics"
                        label="Traffic"
                ></DynamicFields>
              </v-col>
              <v-col cols="7" sm="7" class="col-max-height">
                <v-select
                        v-model="newAffiliate.revenue"
                        :items="revenueOptions"
                        label="How much monthly revenue do you generate?"
                ></v-select>
              </v-col>
              <v-col cols="5" sm="5">
                <v-select
                        v-model="newAffiliate.term"
                        :items="terms"
                        item-text="name"
                        item-value="id"
                        label="Payment Term"
                ></v-select>
              </v-col>
              <v-col cols="6" sm="6" class="col-max-height">
                <v-text-field
                        v-model="newAffiliate.topCountries"
                        label="Top Countries"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" class="col-max-height">
                <v-text-field
                        v-model="newAffiliate.topOffers"
                        label="Top Offers"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <DynamicFields
                        v-model="newAffiliate.websites"
                        label="Web site"
                ></DynamicFields>
              </v-col>
              <v-col cols="12" sm="12">
                <DynamicFields
                        v-model="newAffiliate.networks"
                        label="Network"
                ></DynamicFields>
              </v-col>
              <v-col cols="6" sm="6" class="col-max-height">
                <v-text-field
                        v-model="newAffiliate.companyName"
                        label="Company Name"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" class="col-max-height">
                <v-text-field
                        v-model="newAffiliate.companyAddress"
                        label="Company Address"
                ></v-text-field>
              </v-col>
              <v-col cols="6" sm="6" class="col-max-height">
                <v-select
                        v-model="newAffiliate.method"
                        :items="methods"
                        item-text="name"
                        item-value="id"
                        label="Payment Method"
                ></v-select>
                <span class="custom-error" v-if="showErrors && !newAffiliate.method">Payment method is required</span>
              </v-col>
              <v-col cols="12" sm="12">
                <div v-if="newAffiliate.method">
                  <template v-for="pdField in paymentDetails[newAffiliate.method]">
                    <div class="my-field-group" :key="`field_${pdField.field}`">
                      <template>
                        <v-text-field
                                :id="`field_${pdField.field}`"
                                :name="pdField.field"
                                :rules="pdField.rules"
                                v-model="newAffiliate.paymentDetails[pdField.field]"
                                :label="pdField.label"
                        ></v-text-field>
                      </template>
                    </div>
                  </template>
                </div>
              </v-col>
              <v-col cols="6" sm="6" class="col-max-height">
                <v-text-field
                        v-model="newAffiliate.vat"
                        label="VAT"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
                  color="secondary"
                  text
                  @click="closeModalNewAffiliate"
          >
            Cancel
          </v-btn>
          <v-btn
                  color="primary"
                  text
                  @click="createAAffiliate"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EditProfile from "@/components/pages/affiliates/profiles/EditProfile";
import DataTableTopBar from '@/components/common/DataTableTopBar';
import DynamicFields from "@/components/common/DynamicFields";
import DataTableBottomBar from '@/components/common/DataTableBottomBar';
import {mapActions, mapGetters} from 'vuex'
import store from "@/store";
import affiliatesApi from "@/api/affiliates";
import infoApi from "@/api/info";
import {DateTime} from "luxon";
import {generateLinkWithParams} from "@/helpers/linkGenerator";
import ExportSettingsModal from "./ExportSettingsModal";
import paymentDetails from "@/helpers/paymentDetails";
import affiliates from "@/api/affiliates";

export default {
  props: {
    showSelect: false,
    showActions: {
      default: true
    },
    hideUnrelated: {
      default: false
    },
    preselectedFilters: {
      default: {}
    },
  },
  data() {
    return {
      paymentDetails,
      newAffiliate: {
        verticals: [''],
        traffics: [''],
        websites: [''],
        networks: [''],
        paymentDetails: {},
      },
      terms: [],
      methods: [],
      revenueOptions: [
        "$0 - $500",
        "$500 - $2,500",
        "$2,500 - $5,000",
        "$5,000 - $10,000",
        "$10,000+"
      ],
      showErrors: false,
      isInvalidEmail: false,
      openModalNewAffiliate: false,
      exportSettingsDialog: {
        open: false
      },
      dialog: {
        open: false,
        item: {},
        title: 'New Item'
      },
      table: {
        heightCounter: 45,
        loading: false,
        searchInAffiliates: '',
        awaitingSearch: false,
        currentPage: 1,
        perPage: 25,
        pageChangedByMe: false,
        pageOptions: [10, 25, 50, 100, 500, 1000],
        orderBy: '',
        sortColumnsAsc: true,
        headersUnmuted: [],
        headers: [
          { text: 'Aff Name & Id', value: 'affNameId', class: 'color', align: 'center' }, //
          { text: 'Email', value: 'email', align: 'center' }, //
          { text: 'Status', value: 'status', align: 'center' }, //
          { text: 'Currency', value: 'currency', align: 'center' }, //
          { text: 'Verticals', value: 'verticals', align: 'center' }, //
          { text: 'AM', value: 'affiliateManager', align: 'center' }, //
          { text: 'Billing Cycle', value: 'billingCycle', align: 'center' }, //
          { text: 'Postback Url', value: 'postbackUrl', align: 'center' }, //
          { text: 'Payment Type', value: 'paymentType', align: 'center' }, //
          { text: 'Tier', value: 'tier', align: 'center' }, //
          { text: 'Highest tier', value: 'highest_tier', align: 'center' }, //
          { text: 'Affiliate type', value: 'affiliateType', align: 'center' }, //
          { text: 'Traffic type', value: 'trafficType', align: 'center' }, //
          { text: 'Referred By', value: 'parent', align: 'center' }, //
          { text: 'Date Added', value: 'dateAdded', align: 'center' }, //
          { text: 'Approval Date', value: 'activationDate', align: 'center' }, //
          { text: 'Live Date', value: 'liveDate', align: 'center' }, //
          { text: 'Last Sale Date', value: 'lastSaleDate', align: 'center' }, //
          { text: 'Actions', value: 'actions', align: 'center', sortable: false}
        ],
        filters: {
          affNameId: {selected: [], data: []},
          email: {selected: [], data: []},
          status: {selected: [], data: []},
          paymentType: {selected: [], data: []},
          tier: {selected: [], data: []},
          highest_tier: {selected: [], data: []},
          parent: {selected: [], data: []},
          currency: {selected: [], data: []},
          verticals: {selected: [], data: []},
          affiliateManager: {selected: [], data: []},
          billingCycle: {selected: [], data: []},
          postbackUrl: {selected: [], data: []},
          dateAdded: {selected: [], data: [], isDate: true},
          activationDate: {selected: [], data: [], isDate: true},
          liveDate: {selected: [], data: [], isDate: true},
          lastSaleDate: {selected: [], data: [], isDate: true},
          onlyAssigned: {selected: [], data: []},
          affiliateType: {selected: [], data: []},
          trafficType: {selected: [], data: []},
        }
      },
      filtersMenu: false,
      loading: false,
    }
  },

  async mounted() {
    this.headersUnmuted = [...this.table.headers];
    this.filterHeaders();
    if (!this.showActions) {
      const actionsIndex = this.table.headers.findIndex(h => h.value === 'actions');
      if (actionsIndex > -1) {
        this.table.headers.splice(actionsIndex, 1)
      }
    }
    const userSate = this.$store.state.user;
    if (this.hideUnrelated && !userSate.user[0].can('see_all_affiliates_pii')) {
      if (userSate.user[0].can('see_own_affiliates_pii')) {
        this.table.filters.affiliateManager.selected = userSate.user[0].sfl_manager_id ? [userSate.user[0].sfl_manager_id.toString()] : [];
      } else {
        return;
      }
    }
    if (this.$route.query.filters) {
      this.updateFiltersFromQuery()
    }
    await this.getTableData()
    this.getFiltersData()
  },

  methods: {
    ...mapActions('managers',['generateAgentToken']),
    showContacts() {
      console.log('showContacts')
    },
    filterHeaders() {
      let headersToDisplay = [];
      try {
        const fields = localStorage.getItem('affiliateHeader');
        if (fields) {
          headersToDisplay = JSON.parse(fields);
        }
        if (headersToDisplay.length) {
          this.table.headers = this.headersUnmuted.filter(h => headersToDisplay.includes(h.text));
        }
      } catch (e) {
        console.log(e);
      }
    },
    getPrettyDate(date) {
      return DateTime.fromISO(date).toFormat('MMMM dd, yyyy');
    },
    isEntityName(item) {
      return ['affNameId', 'parent'].includes(item)
    },
    showCard(item, defaultTab, header) {
      const isParent = header === 'parent';
      const path = window.location.host + window.location.pathname
      const affiliateLink = generateLinkWithParams({
        filters: JSON.stringify({
          affNameId: isParent ? [item.parentId] : [item.id]
        })
      }, path);

      const parentItem = {...item, affiliate_id: item.parentId};

      const data = isParent ? parentItem :  {...item, tab: defaultTab};

      store.dispatch('cards/ADD', {
        type: 'affiliate',
        title: isParent ? item.parent : item.name,
        key: isParent ? `affiliate-${item.parentId}` : `affiliate-${item.id}`,
        data,
        affiliateLink
      })
    },
    getFiltersData() {
      const filters = {};
      for(const name in this.table.filters) {
        affiliatesApi.getFilter({
          filter: filters,
          name: name,
        }).then(res => {
          this.table.filters[name].data = res;
        });
      }
    },
    async getTableData() {
      this.table.loading = true
      this.activateFilters()
      const filters = await this.getFilters();
      await store.dispatch('affiliates/getAffiliatesProfileDataCO', {
        payload: {
          limit: this.table.perPage,
          page: this.table.currentPage,
          orderBy: this.table.orderBy || '',
          orderDirectionAsc: this.table.sortColumnsAsc || false,
          filters: filters || null
        }
      })
      this.table.loading = false
    },

    async getTableDataWithoutPagination() {
      this.activateFilters()
      const filters = await this.getFilters();
      await store.dispatch('affiliates/getAffiliatesProfileDataCOWithoutPagination', {
        payload: {
          limit: 999999,
          page: 1,
          orderBy: this.table.orderBy || '',
          orderDirectionAsc: this.table.sortColumnsAsc || false,
          filters: filters || null
        }
      });
    },

    /** todo add to helper */
    addParamsToLocation(params) {
      const query = JSON.stringify(params) === '{}' ? this.$route.path :
          this.$route.path + '?' + Object.keys(params).map(
              key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
          ).join('&')
      history.pushState({},null, query);
    },
    updateFiltersFromQuery() {
      const queryFilters = JSON.parse(this.$route.query.filters);
      for(const name in this.table.filters) {
        if(queryFilters[name]) {
          this.table.filters[name].selected = queryFilters[name];
        }
      }
    },
    async getFilters() {
      const filters = {};
      filters['search'] = (this.table.searchInAffiliates.length > 0) ? this.table.searchInAffiliates : '';
      for(const name in this.table.filters) {
        filters[name] = (this.table.filters[name].selected.length > 0) ?
            `'${this.table.filters[name].selected.join('\',\'')}'` :
            null;
      }

      return filters;
    },
    async submitFilter(data, entity) {
      this.table.currentPage = 1;
      this.table.pageChangedByMe = true;
      if(data && entity) {
        this.table.filters[entity].selected = data;
      }
      return await this.getTableData()
    },
    activateFilters() {
      const filtersForQuery = {};
      const preSelected = Object.keys(this.preselectedFilters);
      if (preSelected.length > 0) {
        preSelected.forEach((name) => {
          this.table.filters[name].selected = this.preselectedFilters[name];
        })
      }
      for (const name in this.table.filters) {
        if(this.table.filters[name].selected.length > 0) {
          filtersForQuery[name] = this.table.filters[name].selected;
        }
      }
      this.addParamsToLocation(
          JSON.stringify(filtersForQuery) !== '{}' ? {filters: JSON.stringify(filtersForQuery)} : {}
      );
    },
    async updateDataInFilters(data, modalName) {
      if(modalName) {
        affiliatesApi.getFilter({
          filter: this.table.filters,
          name: modalName,
          searchFilter: data
        }).then(res => {
          this.table.filters[modalName].data = res;
        });
      }
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = (this.table.orderBy === column) ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = column
      await this.getTableData()
    },
    updateTablePagination(params){
      if (
          (this.table.currentPage === params.page &&
          this.table.perPage === params.itemsPerPage) ||
          this.table.pageChangedByMe
      ) {
        this.table.pageChangedByMe = false;
        return
      }
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage
      if(this.$route.query.filters) {
        this.updateFiltersFromQuery();
      }
      this.getTableData();
    },
    getCampainsUrl(item) {
      const filters = '?filters=' + encodeURI(JSON.stringify({affNameId: [item.id]}))
      return '/affiliates/campaigns' + filters;
    },
    openDialog(item) {
      this.dialog.item = item;
      this.dialog.title = `Edit ${item.affNameId}'s profile`
      this.dialog.open = true;
    },
    search(value) {
      this.table.searchInAffiliates = value
      this.submitFilter();
    },
    async removeAllFilters() {
      for (let key in this.table.filters) {
        this.table.filters[key].selected = [];
      }
      await this.getTableData()
    },
    onSelect($event) {
      this.$emit('selected', $event)
    },
    async generateTokenAndLoginToAffiliate(item) {
      try {
        const userSate = this.$store.state.user;
        const agentName = userSate.user[0].email;
        const userEmail = item.email;
        const obj = {
          agentName,
          userEmail
        };

        const token = await this.generateAgentToken(obj);
        const hostname = window.location.hostname;

        let dashboardUrl = '';
        if (hostname.includes("localhost")) {
          dashboardUrl = 'http://localhost:8081/';
        } else if (hostname.includes("backoffice.aezai.com")) {
          dashboardUrl = 'https://account.ad-firm.com/';
        } else if (hostname.includes("backoffice.kprnt.com")) {
          dashboardUrl = 'https://account.gotzha.com/';
        } else if (hostname.includes("backoffice.stage.kprnt.com")) {
          dashboardUrl = 'https://account.stage.kprnt.com/';
        } else {
          dashboardUrl = 'https://account.stage.ad-firm.com/';
        }
        console.log(`[GENERATE_LOGIN] dashboardUrl:${dashboardUrl} params:${JSON.stringify(obj)}`);

        const url = `${dashboardUrl}auth/agentToken/${token}`;
        window.open(url, '_blank');

      } catch (error) {
        console.error('Error generating token:', error);
      }
    },
    checkPermissions(item) {
      const userSate = this.$store.state.user;
      const isVerified = item.verified !== null;
      const isNotPendingOrRejected = !['pending', 'rejected'].includes(item.status);
      const canSeeOwnAffiliatesPII = userSate.user[0].can('see_own_affiliates_pii') || userSate.user[0].can('see_all_affiliates_pii');

      return isVerified && isNotPendingOrRejected && canSeeOwnAffiliatesPII;
    },
    async activateEmailManually(item) {
      try {
        if (!item.verified) {
          this.loading = true;
          item.verified = new Date().toISOString().slice(0, 19).replace('T', ' ');
          await store.dispatch('affiliates/saveAffiliateProfile', item)
          store.dispatch('alert/ALERT_SUCCESS', `Affiliate email has been activated`, {root: true});
        } else {
          store.dispatch('alert/ALERT_INFO', `Affiliate email is already activated`, {root: true});
        }
        setTimeout(() => {
          store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
        }, 6000);
      } catch (e) {
        store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
        setTimeout(() => {
          store.dispatch('alert/ALERT_REMOVE', ``, {root: true});
        }, 6000);
      }
      this.loading = false;
    },
    exportAffiliatesList() {
      this.exportSettingsDialog.open = !this.exportSettingsDialog.open;
      this.getTableDataWithoutPagination();
    },
    async addAffiliate() {
      try {
        const data = await infoApi.getPaymentInfo();

        if (data) {
          this.terms = data.terms || [];
          this.methods = data.methods || [];
        }
        this.openModalNewAffiliate = true;
      } catch (error) {
        console.error('Error fetching payment info:', error);
      }
    },
    closeModalNewAffiliate() {
      this.openModalNewAffiliate = false;
    },
    validateEmail(email) {
      const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return re.test(email);
    },
    async createAAffiliate() {
      try {

        const exists = await affiliates.isEmailExists(this.newAffiliate.email);
        if (exists) {
          await store.dispatch('alert/ALERT_ERROR', `Email ${this.newAffiliate.email} already exists.`, { root: true });
          return;
        }

        if (!this.newAffiliate || !this.newAffiliate.lastName || !this.newAffiliate.email) {
          this.showErrors = true;
          setTimeout(() => {
            this.showErrors = false;
          }, 3000)
          return;
        }
        if (!this.validateEmail(this.newAffiliate.email)) {
          this.isInvalidEmail = true;
          setTimeout(() => {
            this.isInvalidEmail = false;
          }, 3000)
          return;
        }

        if (!this.newAffiliate.method) {
          store.dispatch('alert/ALERT_ERROR', `Please select a payment method.`, { root: true });
          return;
        }

        if (!this.newAffiliate.paymentDetails && this.newAffiliate.method) {
          this.isInvalidEmail = true;
          setTimeout(() => {
            this.isInvalidEmail = false;
          }, 3000);
          return;
        }

        await affiliatesApi.createAffiliate(this.newAffiliate);
        this.openModalNewAffiliate = false;
        store.dispatch('alert/ALERT_SUCCESS', `Affiliate has been created`, {root: true});
        this.newAffiliate = {
          verticals: [''],
          traffics: [''],
          websites: [''],
          networks: [''],
          paymentDetails: {},
        };
      } catch (e) {
        console.log(e.message);
        store.dispatch('alert/ALERT_ERROR', `An error has occurred.`, {root: true});
      }

    }
  },

  computed: {
    ...mapGetters('affiliates', ['getAffiliatesProfileCO', 'getShouldUpdateColumns'])
  },

  watch: {
    getShouldUpdateColumns: async function () {
      this.filterHeaders();
    }
  },

  components: {
    EditProfile,
    DynamicFields,
    DataTableTopBar,
    DataTableBottomBar,
    ExportSettingsModal
  },
}
</script>

<style lang="sass">
  v-col.new-affiliate
    max-height: 70px !important
.co-data-table
  .v-data-table__wrapper
    .v-data-table-header
      th
        white-space: nowrap
.search_btn_wrap
  h1
    margin-bottom: 0
  .search_wrapper
    width: 250px
    padding-bottom: 15px

.verticals-container
  display: flex
  flex-wrap: wrap
  justify-content: flex-start
  gap: 4px

.tag
  margin: 2px !important
.col-max-height
  max-height: 967px !important
  overflow: hidden !important


</style>
